import React from 'react';
import { PropertyValuationData } from '../../../../types/valuation';
import { MarketAnalysis } from '../MarketAnalysis';
import { PropertyInsights } from '../PropertyInsights';

interface AnalysisSectionProps {
  propertyData: PropertyValuationData;
  transformValue: (value: any) => number;
}

export const AnalysisSection: React.FC<AnalysisSectionProps> = ({
  propertyData,
  transformValue
}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
      <MarketAnalysis 
        propertyData={{
          estimatedValue: transformValue(propertyData.estimatedValue),
          livingArea: transformValue(propertyData.propertyInfo?.livingSquareFeet),
          comps: propertyData.comps
        }}
      />
      <PropertyInsights
        propertyData={{
          propertyInfo: {
            yearBuilt: propertyData.propertyInfo?.yearBuilt,
            lotSquareFeet: transformValue(propertyData.propertyInfo?.lotSquareFeet),
            livingSquareFeet: transformValue(propertyData.propertyInfo?.livingSquareFeet)
          },
          propertyType: propertyData.propertyType,
          ownerOccupied: propertyData.ownerOccupied,
          floodZone: propertyData.floodZone,
          floodZoneDescription: propertyData.floodZoneDescription
        }}
      />
    </div>
  );
};
